import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import CurrencyDialog from "../views/CurrencyDialog";
import CurrencyUpdate from "../views/CurrencyUpdate";
import { Link } from "react-router-dom";
import { FaPaperPlane, FaArrowLeft } from "react-icons/fa";
import { PaginationControl } from "react-bootstrap-pagination-control";
import useCollapse from "react-collapsed";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";
function Dashboard() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  // const url = "https://backendcherryk.cherrykmyanmar.com.:4000/api/";
  const api = apiInstance

  const scroll = {
    height: "600px",
    overflowY: "scroll",
  };
  const [isExpanded, setExpanded] = useState(false);
  const [isAccData, setAccData] = useState(false);

  const { getCollapseProps, getToggleProps } = useCollapse();

  const handleAdminChange = () => {
    setExpanded(!isExpanded);
  };

  const handleAccChange = () => {
    setAccData(!isAccData);
  };
  const [excelList, setExcelList] = useState([]);
  const [purchaseLists, setPurchaseLists] = useState([]);
  const [allcurrencylist, setAllCurrencyLists] = useState([]);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [close, setClose] = useState(false);
  const [code, setCode] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const [id, setId] = useState("");
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const showDialog = () => setOpen(true);
  const showCurrencyUpdate = (val) => {
    setId(val);
    setShowUpdate(true);
  };
  const [dataCount, setDataCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState("");

  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const paginationItems = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return purchaseLists.slice(start, end);
  }, [page, purchaseLists]);
  useEffect(() => {
    const getPurchaseLists = async () => {
      try {
        const res = await api.get("purchase-requests");

        setPurchaseLists(res.data.list);
        setDataCount(res.data.list.length);
        setPages(
          res.data.list.length % rowsPerPage === 0
            ? res.data.list.length / rowsPerPage
            : Math.floor(res.data.list.length / rowsPerPage) + 1,
        );
        // console.log(res.data.list, 'pur list')
      } catch (err) {}
    };
    getPurchaseLists();
  }, []);
  const handleFilterDate = async () => {
    setShow(true);
    const nDate = new Date(to);
    const finalDate = nDate.setDate(nDate.getDate() + 1);
    const data = {
      startDate: from,
      endDate: to,
    };
    const res = purchaseLists.filter(
      (el) =>
        new Date(el.purchaseDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }) >=
          new Date(from).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }) &&
        new Date(el.purchaseDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }) <=
          new Date(to).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }),
    );

    setPurchaseLists(res);
    setDataCount(res.length);
    setPages(
      res.length % rowsPerPage === 0
        ? res.length / rowsPerPage
        : Math.floor(res.length / rowsPerPage) + 1,
    );

    await api
      .get(`purchases/excel`, { params: data })
      .then((res) => {
        setExcelList(res.data.purchaseDatas);
        console.log(
          res.data.purchaseDatas,

          " excel",
        );

        setShow(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
    // setShowSearchDate(false);
    // setShowSearchDate(true);
    // setShowBranchFilter(false);

    // setShowOrigin(true);
  };
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data, "excel");

      _export.current.props.data.map(function (element, index) {
        element.date = element.date?.split("T")[0];
        element.code = element.code;
        element.branchName = element.relatedBranch
          ? element.relatedBranch.name
          : "HO";
        element.typeName = element.item.item_id?.medicineItemName
          ? "Medicine Item"
          : element.item.item_id?.procedureItemName
            ? "Procedure Medicine Item"
            : element.item.item_id?.accessoryItemName
              ? "Accessories Items"
              : element.item.item_id?.generalItemName && "General Items";
        element.name =
          element.item.item_id?.medicineItemName ||
          element.item.item_id?.procedureItemName ||
          element.item.item_id?.accessoryItemName ||
          element.item.item_id?.generalItemName;
      });

      _export.current.save();
    }
  };
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">
                      Purchase Request List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section class="content">
            <div class="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                        <div className="form-group col-md-3">
                          <label>From</label>
                          <input
                            type="date"
                            name="from"
                            id="from"
                            onChange={(e) => setFrom(e.target.value)}
                            className="form-control"
                          />
                        </div>
                        <div className="form-group col-md-3">
                          <label>To</label>
                          <input
                            type="date"
                            name="to"
                            id="to"
                            onChange={(e) => setTo(e.target.value)}
                            className="form-control"
                          />
                        </div>
                        <div className="form-group col-md-1">
                          <button
                            className="btn btn-sm btn-primary"
                            style={{ marginTop: "40px" }}
                            onClick={handleFilterDate}
                          >
                            Search
                          </button>
                        </div>
                        <div className="form-group  col-md-2">
                          <button
                            type="button"
                            style={{ marginTop: "40px" }}
                            disabled={!excelList[0]}
                            className="btn btn-sm btn-success"
                            onClick={excelExport}
                          >
                            {show ? "Loading" : "Export"}
                          </button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 px-2">
                          <span className="text-red">*</span>&nbsp;
                          <span className="text-md text-decoration-underline font-monospace py-2">
                            Please Date Filter For Item Export
                          </span>
                          &nbsp;<span className="text-red">*</span>
                        </div>
                      </div>
                      {/* <h3 className="card-title">Currency List</h3> */}

                      <Link
                        to="/add_purchase"
                        className="btn btn-sm btn-dark float-right rounded-3"
                        data-toggle="modal"
                        data-target="#currency"
                      >
                        <i className="fa fa-plus"></i> &nbsp;Add
                      </Link>
                    </div>
                    <div className="card-body" style={scroll}>
                      <ExcelExport
                        data={excelList}
                        ref={_export}
                        fileName="Stock-Transfer-List.xlsx"
                      >
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="date
"
                          title="Purchase Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />
                        <ExcelExportColumn
                          field="code
"
                          title="Code"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        <ExcelExportColumn
                          field="totalQTY
"
                          title="Total Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="totalPrice
"
                          title="Total Price"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="branchName
"
                          title=" Branch"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="typeName
"
                          title="Item Type"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="item.item_id.code
"
                          title="Item Code"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="name
"
                          title="Item Name"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={450}
                        />

                        <ExcelExportColumn
                          field="item.stockQty"
                          title="Stock Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field="item.requestedQty"
                          title="Requested Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={350}
                        />

                        <ExcelExportColumn
                          field="item.transferQty"
                          title="Transfer Qty"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field="item.subTotal
"
                          title="Item Total Amount"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field="item.item_id.unit"
                          title="Unit"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          cellOptions={{
                            textAlign: "center",
                          }}
                          width={450}
                        />
                      </ExcelExport>
                      <table id="example1" className="table">
                        <thead className="sticky-top bg-light">
                          <tr>
                            <th>No</th>
                            <th>Code</th>
                            <th>Purchase Date</th>

                            <th>Branch</th>
                            <th>Total Qty</th>
                            <th>Total Price</th>
                            <th>Reason</th>

                            <th className="text-center">Action</th>
                          </tr>
                        </thead>

                        <tbody className="">
                          {paginationItems
                            // .sort((a, b) => b.code - a.code)
                            .map((purchaseList, i) => (
                              <tr>
                                <td>{(page - 1) * rowsPerPage + i + 1}</td>
                                <td>{purchaseList?.code}</td>
                                <td>
                                  {purchaseList.purchaseDate?.split("T")[0]}
                                </td>

                                <td>
                                  {purchaseList.relatedBranch
                                    ? purchaseList.relatedBranch.name
                                    : "HO"}
                                </td>
                                <td>{purchaseList.totalQTY}</td>
                                <td>{purchaseList.totalPrice}</td>
                                <td>
                                  {purchaseList.reason
                                    ? purchaseList.reason
                                    : ""}
                                </td>

                                <td className="text-center">
                                  <Link
                                    to={"/purchaseDetail/" + purchaseList._id}
                                    class="btn btn-dark btn-sm"
                                  >
                                    Detail
                                  </Link>
                                  &nbsp;
                                  {purchaseList.relatedApprove ? (
                                    <Link
                                      to={"/pur-tran/" + purchaseList._id}
                                      // state={{ data: purchaseLists }}
                                      className="btn btn-info btn-sm disabled"
                                    >
                                      <FaPaperPlane />
                                    </Link>
                                  ) : (
                                    <Link
                                      to={"/pur-tran/" + purchaseList._id}
                                      // state={{ data: purchaseLists }}
                                      class="btn btn-info btn-sm"
                                    >
                                      <FaPaperPlane />
                                    </Link>
                                  )}
                                </td>
                              </tr>
                            ))}

                          {/* @endforeach */}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-4">
                      <PaginationControl
                        page={page}
                        between={4}
                        total={dataCount}
                        limit={100}
                        changePage={(page) => {
                          setPage(page);
                        }}
                        ellipsis={1}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <CurrencyDialog
                open={open}
                close={() => setOpen(false)}
                setOpen={setOpen}
                setPurchaseLists={setPurchaseLists}
                purchaseLists={purchaseLists}
              />
            </div>
          </section>
        </div>

    </>
  );
}
export default Dashboard;
